import { UcoastEl } from '@/scripts/core/UcoastEl'
import { qsRequired } from '@/scripts/core/global'

export class ExpandableContent extends UcoastEl {
	static htmlSelector = 'expandable-content'
	summary: HTMLElement
	details: HTMLDetailsElement
	content: HTMLElement
	isOpen: boolean
	constructor() {
		super()
		this.summary = qsRequired('summary', this)
		this.content = qsRequired('.accordion__content', this)
		this.details = qsRequired('details', this)
		this.isOpen = false
		this.summary.addEventListener('click', (e) => this.onClick(e))
	}

	onClick(e: Event) {
		e.preventDefault()
		this.style.overflow = 'hidden'
		if (!this.isOpen) {
			this.open()
		} else if (this.isOpen) {
			this.close()
		}
	}

	close() {
		this.content.style.maxHeight = `0px`
		this.isOpen = false

		window.setTimeout(() => {
			this.summary.setAttribute('aria-expanded', 'false')
			this.details.removeAttribute('open')
		}, 350)
	}

	open() {
		console.log('open')
		this.isOpen = true
		this.details.setAttribute('open', '')
		this.summary.setAttribute('aria-expanded', 'true')
		window.setTimeout(() => {
			console.log('{this.content.offsetHeigh', this.content.clientHeight)
			console.log('this.getComputedStyle(this.content).height', this.content.getBoundingClientRect())
			this.content.style.maxHeight = `${this.content.scrollHeight}px`
		}, 2)
	}

	recalculate() {
		if (this.isOpen) {
			this.content.style.maxHeight = `${this.content.scrollHeight}px`
		}
	}

}
